module.exports = __webpack_public_path__ + "assets/2f34ebbeec13a95e2e8aa3730ccc89f5.mp4";